import { render, staticRenderFns } from "./MonitorTrafego.vue?vue&type=template&id=4edd4658"
import script from "./MonitorTrafego.vue?vue&type=script&lang=ts"
export * from "./MonitorTrafego.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports